import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiListeningApiService } from 'src/services/aiListeningApi'

const POLLING_INTERVAL = 4000

export const useGetAiListeningReloadStatusQuery = (
  campaignId: string,
  isPolling: boolean
) => {
  return useQuery({
    enabled: !!campaignId,
    queryFn: () => AiListeningApiService.getReloadStatus(campaignId),
    queryKey: [QueryKey.GET_AI_LISTENING_CAMPAIGN_RELOAD_STATUS, campaignId],
    refetchInterval: isPolling ? POLLING_INTERVAL : false,
  })
}
